/**
 * Tabs
 * Simple tabination
 */

const Tab = {};

Tab.tabs = function (scope) {
  scope = scope || document.querySelector('.tab');
  var handle = 'tab-nav';
  var pane = 'tab-pane';

  var handles = scope.querySelectorAll('.' + handle);
  var i = 0;
  for(i; i < handles.length; i++) {
    handles[i].addEventListener('click', function (e) {
      e = e || window.event;
      if (e.target.classList.contains(handle)) {
        Tab.tabs.open(e.target);
      }
      e.preventDefault();
    });
  }

  Tab.tabs.open(document.querySelector('.' + handle));
};

Tab.tabs.open = function (handle, scope) {
  scope = scope || document.querySelector('.tab');
  var handles = scope.querySelectorAll('.tab-nav');
  var i = 0;
  for(i; i < handles.length; i++)
    handles[i].classList.remove('is-viewing');
  handle.classList.add('is-viewing');

  var tabs = scope.querySelectorAll('.tab-pane');
  i = 0;
  for(i; i < tabs.length; i++)
    tabs[i].classList.add('is-hidden');
  var tab = document.querySelector(handle.dataset.tab);
  tab.classList.remove('is-hidden');
};

export default Tab;



// WEBPACK FOOTER //
// ./components/_tabs.js